module.exports = __webpack_public_path__ + "e705bb4950d4229cf7243a441002d125.svg";